/**
 * Tradovate-style module chrome rule (owner 2026-09-29, "one header row like Tradovate"): a
 * dockview group whose modules are all charts drops the dock's tab row in Tradovate style; the
 * chart's own tab strip then carries the module actions and a drag grip. A floating group keeps its
 * header (it is how a floating window is moved), as does a group that also holds another module.
 * Pure; the web app's workspace/panelChrome.tsx applies it.
 */
/** dockview group location type: "grid", "floating" or "popout". */
export type GroupLocation = string;

export function chartGroupHeaderlessRule(
  kinds: readonly (string | undefined)[],
  location: GroupLocation,
  tradovate: boolean,
): boolean {
  return tradovate && kinds.length > 0 && kinds.every((k) => k === "chart") && location !== "floating";
}
